import { axios } from './config';

export const getDfpNetworkConfig = () => {
	return axios.get(`cb/dfpNetworkConfig/get-config`);
};
